import { configureStore, createSlice } from '@reduxjs/toolkit';

const navbarHeightSlice = createSlice({
  name: 'navbarHeight',
  initialState: 0,
  reducers: {
    setNavbarHeight: (state, action) => {
      return action.payload;
    },
  },
});

export const { setNavbarHeight } = navbarHeightSlice.actions;

export default configureStore({
  reducer: {
    navbarHeight: navbarHeightSlice.reducer,
  },
});
